import { GuennieRating } from './GuennieRating';

/** Eine Kriterium-Zeile im Anzeigemodus (Detailseiten, Durchschnittswerte). */
export function KriteriumAnzeige({
  label,
  wert,
}: {
  label: string;
  wert: number | null | undefined;
}) {
  if (wert === null || wert === undefined) return null;
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.4rem 0',
        borderBottom: '1px solid var(--raspel)',
        gap: '1rem',
      }}
    >
      <span>{label}</span>
      <GuennieRating wert={wert} groesse="sm" />
    </div>
  );
}
